module.exports = __webpack_public_path__ + "img/choose-up-stim.c62f868b.png";